import React, { useContext, useState } from 'react'

import Filter from './Filter'
import List from './List'
import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import WellHeader from './WellHeader'
import { wellPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import { AppStateContext } from '../AppStateContext'

const Explorer = ({ width }) => {
    const name = `Well`
    const {
        filterState,
        updateFilterState,
        syncFilterState,
        promotedRecords,
        togglePromotedRecords,
    } = useContext(AppStateContext)
    const [isCollapsed, setCollapsed] = useState(false)
    const filterExpanded = filterState['well']
    const toggleFilter = updateFilterState.bind(this, 'well')

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div className="explorerWrapper">
                <DataContextProvider>
                    <WellHeader
                        name={name}
                        filterExpanded={filterExpanded}
                        toggleFilter={toggleFilter}
                        promotedRecords={promotedRecords['well']}
                        togglePromotedRecords={togglePromotedRecords}
                        isCollapsed={isCollapsed}
                        setCollapsed={setCollapsed}
                    />
                    <div className={isCollapsed ? `is-collapsed` : ``}>
                        <Filter
                            width={width}
                            filterExpanded={filterExpanded}
                            syncFilterState={syncFilterState}
                        />
                        <List
                            filterExpanded={filterExpanded}
                            promotedRecords={promotedRecords}
                            toggleFilter={toggleFilter}
                        />
                    </div>
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default Explorer
